import { Reconnect } from 'federation/Reconnect';
import React from 'react';
import ReactDOM from 'react-dom';
import type { MFAModalProps } from '../../../../reconnect/src/mfa-aspect/components/MFAModal/MFAModalProps';

const getReactDOM = (): typeof ReactDOM => App.ES6.ReactDOM;

const getRootElement = (): HTMLElement => {
  let mfaAspectRoot = document.getElementById('mfa-aspect-root');
  if (mfaAspectRoot) return mfaAspectRoot;

  mfaAspectRoot = document.createElement('div');
  mfaAspectRoot.id = 'mfa-aspect-root';
  document.body.appendChild(mfaAspectRoot);

  return mfaAspectRoot;
};

// this is not a constructor is a currying function don't be confused with the abysmal similarities that make functional programming to be Actually OOP /s
export const getRenderer = () => {
  const mfaAspectRoot = getRootElement();

  return {
    render(props: Omit<MFAModalProps, 'onCancel'>) {
      const onCancel = () => {
        props.interceptedRequest.cancel();
        this.unmount();
      };

      mfaAspectRoot.style.display = 'block';
      getReactDOM().render(
        <Reconnect name="MFAModal" props={{ ...props, onCancel }} />,
        mfaAspectRoot,
      ); // target element is irrelevant here as Reconnect will route the modal to the right place
    },
    unmount: () => {
      getReactDOM().unmountComponentAtNode(mfaAspectRoot);
      mfaAspectRoot.style.display = 'none';
    },
  };
};
